export const environment = {
  production: false,
  API: 'https://api.sketchplaydev.com/',
  webAppUrl: 'https://web.sketchplaydev.com/',
  camp_clinic_limit: 10,
  orgId: -1,
  pvaaOrg: -1,
  calusaOrg: -1,
  gridirongangOrgId: -1,
  lacOrgs: [-1],
  coreHoopsOrgId: -1,
  xtremeDedicationTraining: -1,
  unpublishOrgTournamentRegisterSubdomain: 'tournaments',
  hidingRegisterButtonFor1020event: 199,
  POSTHOG_KEY: '',
  POSTHOG_HOST: '',
  googleMapsApiKey: 'AIzaSyBXInESe57nPXlBCzgLwHIuAet8r3yh00Q',
  qrcRegistrationSubdomain: 'qrc-registration',
  mediaApiKey: 'sk_media_wwVR0hiWVyLBU872L4D7DYayr6gQWQAq',
};
